// extracted by mini-css-extract-plugin
module.exports = {"customizableText":"ChangeRequestDialog_customizableText__3so7P"};